(function () {
  if (window.__autoplayVideoInit) return;
  window.__autoplayVideoInit = true;

  var videos = [].slice.call(document.querySelectorAll('video.js-autoplay-video'));
  if (!videos.length) return;

  function tryPlay(v) {
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  function inView(v) {
    var r = v.getBoundingClientRect();
    return r.bottom > 0 && r.top < window.innerHeight;
  }

  videos.forEach(function (v) {
    v.muted = true;
    v.defaultMuted = true;
    v.playsInline = true;
    v.removeAttribute('controls');
  });

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) {
            if (v.preload !== 'auto') v.preload = 'auto';
            tryPlay(v);
          } else {
            v.pause();
          }
        });
      },
      { rootMargin: '50% 0px' }
    );
    videos.forEach(function (v) {
      io.observe(v);
    });
  } else {
    videos.forEach(tryPlay);
  }

  // Some phones (low power mode, data saver) refuse autoplay until the first touch: retry then.
  function unlock() {
    videos.forEach(function (v) {
      if (v.paused && inView(v)) tryPlay(v);
    });
  }
  ['touchstart', 'touchend', 'pointerdown', 'click', 'scroll'].forEach(function (ev) {
    window.addEventListener(ev, unlock, { passive: true, once: true });
  });
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) unlock();
  });
})();
